import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-validator-wrapper',{on:{"submit":function($event){return _vm.$emit('submit')}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
return [_c('scrollable',{attrs:{"height":("calc(100vh - " + (_vm.$vuetify.application.top) + "px)")},scopedSlots:_vm._u([{key:"sticky",fn:function(){return [_c(VCard,{attrs:{"flat":""}},[_vm._t("top",null,{"valid":valid})],2),_c(VDivider)]},proxy:true},{key:"scrollable",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }